/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// @ts-ignore
import type { ConfigurationParameters } from "../configuration";
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from "../configuration";
// @ts-ignore
import type { AxiosError, AxiosResponse } from "axios";
import {
  useQuery,
  UseMutationOptions,
  useMutation,
  UseQueryOptions,
  // @ts-ignore
} from "react-query";
// @ts-ignore
import {
  useAuthorizationToken,
  useAuthQueryKey,
  useApiBasePath,
} from "../../utils";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { AirportResourcesDto } from "../models";
// @ts-ignore
import { DayResourcesPropagationDto } from "../models";
// @ts-ignore
import { DaySlotResourcesAllocationDto } from "../models";
// @ts-ignore
import { DaySlotResourcesAllocationResponse } from "../models";
// @ts-ignore
import { TurnaroundResourcesUpdateDto } from "../models";
/**
 * ResourcesWebServicesApi - axios parameter creator
 * @export
 */
export const ResourcesWebServicesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {DaySlotResourcesAllocationDto} daySlotResourcesAllocationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    autoAllocateDaySlotResources: async (
      daySlotResourcesAllocationDto: DaySlotResourcesAllocationDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'daySlotResourcesAllocationDto' is not null or undefined
      assertParamExists(
        "autoAllocateDaySlotResources",
        "daySlotResourcesAllocationDto",
        daySlotResourcesAllocationDto
      );
      const localVarPath = `/resources/day/allocate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        daySlotResourcesAllocationDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAirportResources: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/resources`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DayResourcesPropagationDto} dayResourcesPropagationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propagateDayResources: async (
      dayResourcesPropagationDto: DayResourcesPropagationDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dayResourcesPropagationDto' is not null or undefined
      assertParamExists(
        "propagateDayResources",
        "dayResourcesPropagationDto",
        dayResourcesPropagationDto
      );
      const localVarPath = `/resources/day/propagate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        dayResourcesPropagationDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {TurnaroundResourcesUpdateDto} turnaroundResourcesUpdateDto
     * @param {boolean} [propagate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTurnaroundResources: async (
      turnaroundResourcesUpdateDto: TurnaroundResourcesUpdateDto,
      propagate?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'turnaroundResourcesUpdateDto' is not null or undefined
      assertParamExists(
        "updateTurnaroundResources",
        "turnaroundResourcesUpdateDto",
        turnaroundResourcesUpdateDto
      );
      const localVarPath = `/resources/slot/occurrence`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (propagate !== undefined) {
        localVarQueryParameter["propagate"] = propagate;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        turnaroundResourcesUpdateDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<TurnaroundResourcesUpdateDto>} turnaroundResourcesUpdateDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTurnaroundsResources: async (
      turnaroundResourcesUpdateDto: Array<TurnaroundResourcesUpdateDto>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'turnaroundResourcesUpdateDto' is not null or undefined
      assertParamExists(
        "updateTurnaroundsResources",
        "turnaroundResourcesUpdateDto",
        turnaroundResourcesUpdateDto
      );
      const localVarPath = `/resources/day/occurrences`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        turnaroundResourcesUpdateDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ResourcesWebServicesApi - functional programming interface
 * @export
 */
export const ResourcesWebServicesApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    ResourcesWebServicesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {DaySlotResourcesAllocationDto} daySlotResourcesAllocationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async autoAllocateDaySlotResources(
      daySlotResourcesAllocationDto: DaySlotResourcesAllocationDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DaySlotResourcesAllocationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.autoAllocateDaySlotResources(
          daySlotResourcesAllocationDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAirportResources(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AirportResourcesDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAirportResources(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {DayResourcesPropagationDto} dayResourcesPropagationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propagateDayResources(
      dayResourcesPropagationDto: DayResourcesPropagationDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propagateDayResources(
          dayResourcesPropagationDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {TurnaroundResourcesUpdateDto} turnaroundResourcesUpdateDto
     * @param {boolean} [propagate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTurnaroundResources(
      turnaroundResourcesUpdateDto: TurnaroundResourcesUpdateDto,
      propagate?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateTurnaroundResources(
          turnaroundResourcesUpdateDto,
          propagate,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {Array<TurnaroundResourcesUpdateDto>} turnaroundResourcesUpdateDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTurnaroundsResources(
      turnaroundResourcesUpdateDto: Array<TurnaroundResourcesUpdateDto>,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateTurnaroundsResources(
          turnaroundResourcesUpdateDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
  };
};

/**
 * ResourcesWebServicesApi - factory interface
 * @export
 */
export const ResourcesWebServicesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ResourcesWebServicesApiFp(configuration);
  return {
    /**
     *
     * @param {ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    autoAllocateDaySlotResources(
      requestParameters: ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<DaySlotResourcesAllocationResponse> {
      return localVarFp
        .autoAllocateDaySlotResources(
          requestParameters.daySlotResourcesAllocationDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAirportResources(
      options?: AxiosRequestConfig
    ): AxiosPromise<AirportResourcesDto> {
      return localVarFp
        .getAirportResources(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ResourcesWebServicesApiPropagateDayResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propagateDayResources(
      requestParameters: ResourcesWebServicesApiPropagateDayResourcesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .propagateDayResources(
          requestParameters.dayResourcesPropagationDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ResourcesWebServicesApiUpdateTurnaroundResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTurnaroundResources(
      requestParameters: ResourcesWebServicesApiUpdateTurnaroundResourcesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .updateTurnaroundResources(
          requestParameters.turnaroundResourcesUpdateDto,
          requestParameters.propagate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTurnaroundsResources(
      requestParameters: ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .updateTurnaroundsResources(
          requestParameters.turnaroundResourcesUpdateDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for autoAllocateDaySlotResources operation in ResourcesWebServicesApi.
 * @export
 * @interface ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest
 */
export interface ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest {
  /**
   *
   * @type {DaySlotResourcesAllocationDto}
   * @memberof ResourcesWebServicesApiAutoAllocateDaySlotResources
   */
  readonly daySlotResourcesAllocationDto: DaySlotResourcesAllocationDto;
}

/**
 * Request parameters for propagateDayResources operation in ResourcesWebServicesApi.
 * @export
 * @interface ResourcesWebServicesApiPropagateDayResourcesRequest
 */
export interface ResourcesWebServicesApiPropagateDayResourcesRequest {
  /**
   *
   * @type {DayResourcesPropagationDto}
   * @memberof ResourcesWebServicesApiPropagateDayResources
   */
  readonly dayResourcesPropagationDto: DayResourcesPropagationDto;
}

/**
 * Request parameters for updateTurnaroundResources operation in ResourcesWebServicesApi.
 * @export
 * @interface ResourcesWebServicesApiUpdateTurnaroundResourcesRequest
 */
export interface ResourcesWebServicesApiUpdateTurnaroundResourcesRequest {
  /**
   *
   * @type {TurnaroundResourcesUpdateDto}
   * @memberof ResourcesWebServicesApiUpdateTurnaroundResources
   */
  readonly turnaroundResourcesUpdateDto: TurnaroundResourcesUpdateDto;

  /**
   *
   * @type {boolean}
   * @memberof ResourcesWebServicesApiUpdateTurnaroundResources
   */
  readonly propagate?: boolean;
}

/**
 * Request parameters for updateTurnaroundsResources operation in ResourcesWebServicesApi.
 * @export
 * @interface ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest
 */
export interface ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest {
  /**
   *
   * @type {Array<TurnaroundResourcesUpdateDto>}
   * @memberof ResourcesWebServicesApiUpdateTurnaroundsResources
   */
  readonly turnaroundResourcesUpdateDto: Array<TurnaroundResourcesUpdateDto>;
}

/**
 * ResourcesWebServicesApi - object-oriented interface
 * @export
 * @class ResourcesWebServicesApi
 * @extends {BaseAPI}
 */
export class ResourcesWebServicesApi extends BaseAPI {
  /**
   *
   * @param {ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesWebServicesApi
   */
  public autoAllocateDaySlotResources(
    requestParameters: ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest,
    options?: AxiosRequestConfig
  ) {
    return ResourcesWebServicesApiFp(this.configuration)
      .autoAllocateDaySlotResources(
        requestParameters.daySlotResourcesAllocationDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesWebServicesApi
   */
  public getAirportResources(options?: AxiosRequestConfig) {
    return ResourcesWebServicesApiFp(this.configuration)
      .getAirportResources(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ResourcesWebServicesApiPropagateDayResourcesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesWebServicesApi
   */
  public propagateDayResources(
    requestParameters: ResourcesWebServicesApiPropagateDayResourcesRequest,
    options?: AxiosRequestConfig
  ) {
    return ResourcesWebServicesApiFp(this.configuration)
      .propagateDayResources(
        requestParameters.dayResourcesPropagationDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ResourcesWebServicesApiUpdateTurnaroundResourcesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesWebServicesApi
   */
  public updateTurnaroundResources(
    requestParameters: ResourcesWebServicesApiUpdateTurnaroundResourcesRequest,
    options?: AxiosRequestConfig
  ) {
    return ResourcesWebServicesApiFp(this.configuration)
      .updateTurnaroundResources(
        requestParameters.turnaroundResourcesUpdateDto,
        requestParameters.propagate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesWebServicesApi
   */
  public updateTurnaroundsResources(
    requestParameters: ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest,
    options?: AxiosRequestConfig
  ) {
    return ResourcesWebServicesApiFp(this.configuration)
      .updateTurnaroundsResources(
        requestParameters.turnaroundResourcesUpdateDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

// custom hook generation here
export type PostAutoAllocateDaySlotResourcesResponse =
  AxiosResponse<DaySlotResourcesAllocationResponse>;
export const KeyPostAutoAllocateDaySlotResources =
  "PostAutoAllocateDaySlotResources";
export const useMutationPostAutoAllocateDaySlotResources = (
  options?: UseMutationOptions<
    PostAutoAllocateDaySlotResourcesResponse,
    AxiosError,
    ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostAutoAllocateDaySlotResourcesResponse,
    AxiosError,
    ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest
  >(
    (args: ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest) =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).autoAllocateDaySlotResources(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostAutoAllocateDaySlotResources = (
  args: ResourcesWebServicesApiAutoAllocateDaySlotResourcesRequest,
  options?: UseQueryOptions<
    PostAutoAllocateDaySlotResourcesResponse,
    AxiosError
  >,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostAutoAllocateDaySlotResourcesResponse, AxiosError>(
    [
      KeyPostAutoAllocateDaySlotResources,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).autoAllocateDaySlotResources(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type GetGetAirportResourcesResponse = AxiosResponse<AirportResourcesDto>;
export const KeyGetGetAirportResources = "GetGetAirportResources";
export const useMutationGetGetAirportResources = (
  options?: UseMutationOptions<GetGetAirportResourcesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<GetGetAirportResourcesResponse, AxiosError>(
    () =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).getAirportResources(axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetGetAirportResources = (
  options?: UseQueryOptions<GetGetAirportResourcesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetGetAirportResourcesResponse, AxiosError>(
    [KeyGetGetAirportResources, options && options.queryKey, authQueryKey],
    () =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).getAirportResources(axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostPropagateDayResourcesResponse = AxiosResponse<void>;
export const KeyPostPropagateDayResources = "PostPropagateDayResources";
export const useMutationPostPropagateDayResources = (
  options?: UseMutationOptions<
    PostPropagateDayResourcesResponse,
    AxiosError,
    ResourcesWebServicesApiPropagateDayResourcesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostPropagateDayResourcesResponse,
    AxiosError,
    ResourcesWebServicesApiPropagateDayResourcesRequest
  >(
    (args: ResourcesWebServicesApiPropagateDayResourcesRequest) =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).propagateDayResources(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostPropagateDayResources = (
  args: ResourcesWebServicesApiPropagateDayResourcesRequest,
  options?: UseQueryOptions<PostPropagateDayResourcesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostPropagateDayResourcesResponse, AxiosError>(
    [
      KeyPostPropagateDayResources,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).propagateDayResources(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostUpdateTurnaroundResourcesResponse = AxiosResponse<void>;
export const KeyPostUpdateTurnaroundResources = "PostUpdateTurnaroundResources";
export const useMutationPostUpdateTurnaroundResources = (
  options?: UseMutationOptions<
    PostUpdateTurnaroundResourcesResponse,
    AxiosError,
    ResourcesWebServicesApiUpdateTurnaroundResourcesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostUpdateTurnaroundResourcesResponse,
    AxiosError,
    ResourcesWebServicesApiUpdateTurnaroundResourcesRequest
  >(
    (args: ResourcesWebServicesApiUpdateTurnaroundResourcesRequest) =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).updateTurnaroundResources(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostUpdateTurnaroundResources = (
  args: ResourcesWebServicesApiUpdateTurnaroundResourcesRequest,
  options?: UseQueryOptions<PostUpdateTurnaroundResourcesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostUpdateTurnaroundResourcesResponse, AxiosError>(
    [
      KeyPostUpdateTurnaroundResources,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).updateTurnaroundResources(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type PostUpdateTurnaroundsResourcesResponse = AxiosResponse<void>;
export const KeyPostUpdateTurnaroundsResources =
  "PostUpdateTurnaroundsResources";
export const useMutationPostUpdateTurnaroundsResources = (
  options?: UseMutationOptions<
    PostUpdateTurnaroundsResourcesResponse,
    AxiosError,
    ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostUpdateTurnaroundsResourcesResponse,
    AxiosError,
    ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest
  >(
    (args: ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest) =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).updateTurnaroundsResources(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostUpdateTurnaroundsResources = (
  args: ResourcesWebServicesApiUpdateTurnaroundsResourcesRequest,
  options?: UseQueryOptions<PostUpdateTurnaroundsResourcesResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostUpdateTurnaroundsResourcesResponse, AxiosError>(
    [
      KeyPostUpdateTurnaroundsResources,
      args,
      options && options.queryKey,
      authQueryKey,
    ],
    () =>
      new ResourcesWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).updateTurnaroundsResources(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
